import React, { useEffect } from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Pequi from '../../../front-novo/icons/Pequi.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Sol from '../../../front-novo/icons/Sol.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';
import { useHistory } from 'react-router-dom'; // Importando useHistory para a navegação

function Home2() {
  const history = useHistory(); // Criando uma função de navegação

  const handleNavigation = () => {
    history.push('/servicos'); // Redireciona para a página /services
  };
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <S.divP>
            <h1>O PROJETO</h1>
            <p>
              Travessias é um coletivo de psicanalistas em Belo Horizonte,
              dedicado a criar uma rede contínua de formação em psicanálise.
              Nosso compromisso é com a excelência em teoria, supervisão e
              prática clínica.
            </p>
          </S.divP>
          <section>
            <h1>O QUE OFERECEMOS</h1>
            <S.TextHorizontal>
              <div>
                <img src={Pequi} />
                <p>PALESTRAS E SEMINÁRIOS </p>
                <hr />
                <p>
                  Eventos que promovem o aprofundamento teórico e a troca de
                  conhecimentos.
                </p>
              </div>
              <div>
                <img src={Tronco} />
                <p>MINICURSOS</p>
                <hr />
                <p>
                  Cursos intensivos focados em temas específicos da psicanálise.
                </p>
              </div>
              <div>
                <img src={Sol} />
                <p>GRUPOS DE ESTUDO</p>
                <hr />

                <p>
                  Espaços colaborativos para discussão e análise de obras
                  psicanalíticas.
                </p>
              </div>
              <div>
                <img src={Gaviao} />
                <p>SUPERVISÕES</p>
                <hr />

                <p> Acompanhamento e orientação para a prática clínica.</p>
              </div>
            </S.TextHorizontal>
          </section>
          <S.Card>
            <S.borderCard>
              <div>
                <div>
                  <S.divPCard>
                    <h1>IMPACTO SOCIAL</h1>
                    <p>
                      Estamos empenhados em tornar a psicanálise acessível a
                      todes. Nosso objetivo é oferecer espaços de cuidado e
                      acolhimento, ampliando o alcance da psicanálise.
                    </p>
                  </S.divPCard>
                </div>
              </div>
              <img src={bordercardimg} />
            </S.borderCard>
            <button onClick={handleNavigation}>Serviços </button>
          </S.Card>
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home2;
